export function createAirportsSummary(airports) {
  let summary = { total: { types: {} } };

  if (Array.isArray(airports)) {
    for (const airport of airports) {
      const country = airport.country.iso;

      if (!summary.hasOwnProperty(country)) {
        summary[country] = { types: {} };
      }

      summary.total.types.hasOwnProperty(airport.type)
        ? summary.total.types[airport.type]++
        : (summary.total.types[airport.type] = 1);
      summary[country].types.hasOwnProperty(airport.type)
        ? summary[country].types[airport.type]++
        : (summary[country].types[airport.type] = 1);
    }
  }

  return summary;
}

export function createRoutesSummary(routes) {
  if (Array.isArray(routes)) {
  }
}
